<template>
    <div class="section bottom-space-xl">
        <div class="container">
            <div class="column-wrapper">
                <div v-if="sendSuccess || sendError" class="column-block _1-3 responsiv-1-4"></div>
                <div class="column-block _1-3 responsiv-1-4">
                    <div class="texts" :class="{ 'successorerror' : sendSuccess || sendError }">
                        <h2 v-if="displayContent.headline" v-html="displayContent.headline" :class="[ sendError ? 'errorText' : '', sendSuccess ? 'successText' : '']"></h2>
                        <div v-if="displayContent.text" v-html="displayContent.text" class="basic-text"></div>
                    </div>
                </div>
                <div class="column-block" v-if="!sendError && !sendSuccess">
                    <div class="contactForm filter-form-block-3 w-form">
                        <form @keydown.enter.prevent>
                            <fieldset>
                                <legend class="sr-only">
                                    <span class="headline m">Kontaktanfrage</span>
                                </legend>
                                <div class="fields-wrapper-auto-wrap-2">
                                    <div class="form-field-wrapper-2 _50percent">
                                        <label for="company">Firma</label>
                                        <input
                                            v-model="contactData.company" type="text" class="standard-field-2 w-input" autocomplete="organization"
                                            maxlength="256" name="company" placeholder="Firma" id="company"  required aria-required
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent">
                                        <label for="company">Funktion</label>
                                        <input
                                            v-model="contactData.position" type="text" class="standard-field-2 w-input"
                                            maxlength="256" name="function" placeholder="Funktion" id="position"
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2 _100percent">
                                        <label for="salutation">Anrede</label>
                                        <select id="salutation" name="salutation" class="standard-field-2" v-model="contactData.salutation" required aria-required>
                                            <option value="Anrede" disabled selected>Anrede</option>
                                            <option value="Herr">Herr</option>
                                            <option value="Frau">Frau</option>
                                            <option value="Divers">Divers</option>
                                            <option value="Keine Angabe">Keine Angabe</option>
                                        </select>
                                        <div class="field-icon top" aria-hidden="true"></div>
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent" :class="{ 'error' : v$.firstname.$errors.length }">
                                        <label for="firstname">Vorname*</label>
                                        <input
                                            v-model="contactData.firstname" type="text" class="standard-field-2 w-input" autocomplete="given-name"
                                            maxlength="256" name="firstname" placeholder="Vorname *" id="firstname" required aria-required
                                        >
                                        <div class="input-errors" v-for="error of v$.firstname.$errors" :key="error.$uid">
                                            <div class="error-msg">{{ error.$message }}</div>
                                        </div>
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent" :class="{ 'error' : v$.lastname.$errors.length }">
                                        <label for="lastname">Nachname*</label>
                                        <input
                                            v-model="contactData.lastname" type="text" class="standard-field-2 w-input" autocomplete="family-name"
                                            maxlength="256" name="lastname" placeholder="Nachname *" id="lastname" required aria-required
                                        >
                                        <div class="input-errors" v-for="error of v$.lastname.$errors" :key="error.$uid">
                                            <div class="error-msg">{{ error.$message }}</div>
                                        </div>
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent">
                                        <label for="street">Straße und Hausnummer</label>
                                        <input
                                            v-model="contactData.street" type="text" class="standard-field-2 w-input" autocomplete="address-line1"
                                            maxlength="256" name="street" placeholder="Straße und Hausnummer" id="street" required aria-required
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2">
                                        <label for="postalcode">PLZ</label>
                                        <input
                                            v-model="contactData.postalcode" type="text" class="standard-field-2 w-input" autocomplete="postal-code"
                                            maxlength="256" name="postalcode" placeholder="PLZ" id="postalcode" required aria-required
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2">
                                        <label for="city">Ort</label>
                                        <input
                                            v-model="contactData.city" type="text" class="standard-field-2 w-input" autocomplete="address-level2"
                                            maxlength="256" name="city" placeholder="Ort" id="city" required aria-required
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent with-spacing">
                                        <label for="country">Land</label>
                                        <select name="country" id="country" class="standard-field-2" v-model="contactData.country" required aria-required>
                                            <option value="Land" disabled selected>Land</option>
                                            <option v-for="country in countries" :key="country.id">{{ country.name }}</option>
                                        </select>
                                        <div class="field-icon top" aria-hidden="true"></div>
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent" :class="{ 'error' : v$.email.$errors.length }">
                                        <label for="email">E-Mail*</label>
                                        <input
                                            v-model="contactData.email" type="email" class="standard-field-2 w-input" maxlength="256" name="email"  autocomplete="email"
                                            placeholder="E-Mail *" id="email" required aria-required
                                        >
                                        <div class="input-errors" v-for="error of v$.email.$errors" :key="error.$uid">
                                            <div class="error-msg">{{ error.$message }}</div>
                                        </div>
                                    </div>
                                    <div class="form-field-wrapper-2 _50percent">
                                        <label for="phone">Telefon</label>
                                        <input
                                            v-model="contactData.phone" type="text" class="standard-field-2 w-input" maxlength="256" name="phone" autocomplete="tel"
                                            placeholder="Telefonnummer" id="phone" required aria-required
                                        >
                                    </div>
                                    <div class="form-field-wrapper-2 _100percent">
                                        <label for="message">Ihre Mitteilung</label>
                                        <textarea
                                            v-model="contactData.message" rows="8" class="standard-field-2 w-input" name="message"
                                            placeholder="Ihre Nachricht an uns" id="message"
                                        ></textarea>
                                    </div>
                                </div>
                                <div class="fields-wrapper-auto-wrap-2" v-if="formCheckboxes.length > 0">
                                    <div class="texts" v-if="optionsheadline || optionsintro">
                                        <h2 v-if="optionsheadline" v-html="optionsheadline"></h2>
                                        <div v-if="optionsintro" v-html="optionsintro" class="basic-text"></div>
                                        <br />
                                    </div>
                                    <div class="form-field-wrapper-2 _100percent">
                                        <div v-for="(checkbox, checkboxIndex) in formCheckboxes" :key="checkboxIndex">
                                            <label class="w-checkbox checkbox-field-2">
                                                <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox" :class="{ 'w--redirected-checked' : formCheckboxes[checkboxIndex].value }"></div>
                                                <input type="checkbox" v-model="formCheckboxes[checkboxIndex].value" :id="`checkbox-${checkboxIndex}`" name="data-security" style="opacity:0;position:absolute;z-index:-1" required>
                                                <span class="in-form w-form-label" :for="`checkbox-${checkboxIndex}`" v-html="removeOuterHTMLpTag(checkbox.label)"></span>
                                            </label>
                                            <div v-if="checkbox.needsAgreement && formCheckboxes[checkboxIndex].value" class="agreement">
                                                <label class="w-checkbox checkbox-field-2">
                                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox" :class="{ 'w--redirected-checked' : formCheckboxes[checkboxIndex].agreed }"></div>
                                                    <input type="checkbox" v-model="formCheckboxes[checkboxIndex].agreed" :id="`checkbox-${checkboxIndex}`" name="data-security" style="opacity:0;position:absolute;z-index:-1" required>
                                                    <span class="in-form w-form-label" :for="`checkbox-${checkboxIndex}`" v-html="removeOuterHTMLpTag(checkbox.agreementText)"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-field-wrapper-2 _100percent w-clearfix">
                                    </div>
                                </div>
                                <div v-if="disableSend" class="form-button-wrapper errorText">
                                    <div class="basic-text">{{ missingNote }}</div>
                                </div>
                                <div class="form-button-wrapper">
                                    <div class="friendlyWidgetContainer" ref="friendlyWidgetContainer"></div>
                                </div>
                                <div class="form-button-wrapper">
                                    <button
                                        type="button"
                                        @click="sendNow"
                                        v-html="labelsendbutton ? 'Senden' : labelsendbutton"
                                        class="button royal-hell w-button"
                                        :disabled="disableSend"
                                        :class="[{ 'disabled' : disableSend || loading }, { 'loading' : loading }]"
                                    >
                                    </button>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
import {
    computed,
    ref,
    reactive,
    onMounted,
    toRaw
} from 'vue/dist/vue.esm-bundler';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import {
    required, email, helpers
} from '@vuelidate/validators';
import { WidgetInstance } from 'friendly-challenge';
import { useToast } from 'vue-toast-notification';
import countries from './data/countries.json';

export default {
    name: 'ContactForm',
    props: {
        labelsendbutton: {
            type: String,
            default: 'Anmelden'
        },
        headline: {
            type: String,
            default: null
        },
        intro: {
            type: String,
            default: null
        },
        headlinesuccess: {
            type: String,
            default: ''
        },
        textsuccess: {
            type: String,
            default: ''
        },
        headlineerror: {
            type: String,
            default: ''
        },
        texterror: {
            type: String,
            default: ''
        },
        optionsheadline: {
            type: String,
            default: ''
        },
        optionsintro: {
            type: String,
            default: ''
        },
        orderoptions: {
            type: String,
            default: null
        }
    },
    setup(props) {
        const loading = ref(false);
        const store = useStore();
        const toast = useToast();
        const sendSuccess = ref(false);
        const sendError = ref(false);
        const friendlyWidgetContainer = ref(null);
        const friendlyWidget = ref();
        const captcha = ref(false);
        const missingNote = ref('Es fehlen noch benötigte Daten');
        let formCheckboxes;

        if (props.orderoptions) {
            formCheckboxes = reactive(JSON.parse(props.orderoptions).map((el) => ({
                ...el,
                value: false,
                agreed: false
            })));
        } else {
            formCheckboxes = [];
        }

        const friendlyWidgetDoneCallback = () => {
            captcha.value = !captcha.value;
        };

        onMounted(() => {
            friendlyWidget.value = new WidgetInstance(friendlyWidgetContainer.value, {
                startMode: 'none',
                language: 'de',
                sitekey: 'FCMMFSTRI7JOG5O1',
                doneCallback: friendlyWidgetDoneCallback
            });
        });

        const contactData = ref({
            salutation: 'Anrede',
            company: '',
            position: '',
            firstname: '',
            lastname: '',
            street: '',
            postalcode: '',
            city: '',
            country: 'Land',
            email: '',
            phone: '',
            message: ''
        });

        const contactRules = {
            firstname: {
                required: helpers.withMessage('Vorname benötigt', required),
                $autoDirty: true
            },
            lastname: {
                required: helpers.withMessage('Nachname benötigt', required),
                $autoDirty: true
            },
            email: {
                email: helpers.withMessage('Ungültige E-Mail Adresse', email),
                required: helpers.withMessage('E-Mail benötigt', required),
                $autoDirty: true
            },
        };

        const v$ = useVuelidate(contactRules, contactData);

        const removeOuterHTMLpTag = (htmlString) => {
            const newString = htmlString.replace('<p>', '').replace('</p>', '');
            return newString;
        };

        const displayContent = computed(() => {
            if (sendSuccess.value) {
                return {
                    headline: props.headlinesuccess,
                    text: props.textsuccess
                };
            }
            if (sendError.value) {
                return {
                    headline: props.headlineerror,
                    text: props.texterror
                };
            }
            return {
                headline: props.headline,
                text: props.intro
            };
        });

        const disableSend = computed(() => {
            if (formCheckboxes.some((e) => e.value && e.needsAgreement && !e.agreed)) {
                missingNote.value = 'Wir benötigen noch deine Einwilligung';
                return true;
            }
            if (contactData.value.email === '' || contactData.value.firstname === '' || contactData.value.lastname === '') {
                missingNote.value = 'Es fehlen noch benötigte Daten';
                return true;
            }
            if (!captcha.value) {
                missingNote.value = 'Bitte bestätige noch die Anti-Roboter-Verifizierung';
                return true;
            }
            return false;
        });

        const sendNow = async() => {
            loading.value = true;
            console.log(toRaw(formCheckboxes));
            const checkboxes = toRaw(formCheckboxes).filter((fcb) => fcb.value);
            const contactDataObj = {
                salutation: contactData.value.salutation,
                company: contactData.value.company,
                position: contactData.value.position,
                firstname: contactData.value.firstname,
                lastname: contactData.value.lastname,
                street: contactData.value.street,
                postalcode: contactData.value.postalcode,
                city: contactData.value.city,
                country: contactData.value.country,
                email: contactData.value.email,
                phone: contactData.value.phone,
                message: contactData.value.message,
                checkboxes
            };
            try {
                const response = await store.state.api.post('/contactform/v1/send', contactDataObj);
                console.log(response.data);
                if (response.data.message === 'success') {
                    toast.open({
                        message: 'Formular erfolgreich gesendet',
                        type: 'success',
                        position: 'top-right',
                        duration: 5000
                    });
                    sendSuccess.value = true;
                }
                if (response.data.message === 'error') {
                    sendError.value = true;
                    toast.open({
                        message: 'Fehler beim Senden des Formulars',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000
                    });
                }
            } catch (error) {
                console.log(error);
                sendError.value = true;
                toast.open({
                    message: 'Fehler beim Senden des Formulars',
                    type: 'error',
                    position: 'top-right',
                    duration: 5000
                });
            } finally {
                loading.value = false;
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        };

        return {
            loading,
            missingNote,
            contactData,
            sendNow,
            sendSuccess,
            sendError,
            displayContent,
            disableSend,
            v$,
            friendlyWidget,
            friendlyWidgetContainer,
            removeOuterHTMLpTag,
            countries,
            formCheckboxes
        };
    },
};
</script>

<style lang="scss" scoped>
    .requiredNote {
        margin-top: 5px;
        margin-bottom: 20px;
    }

    .texts h2 {
        margin-top: 0;
    }

    .filter-form-block-3 {
        margin-top: 0;
    }

    .w-checkbox {
        display: flex;
    }
    .w-form-label {
        margin-left: 10px;
    }
    .agreement {
        padding-left: 34px;
    }
</style>

<style lang="scss">
.texts {

    p {
        margin-bottom: 10px;
    }
}
</style>
